
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/txn-withdrawals",
      function () {
        return require("private-next-pages/txn-withdrawals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/txn-withdrawals"])
      });
    }
  